import { License } from "../../Models/License";
import { Interface, DataConnections } from "../../Models/Interface";
import { ProjectFormData } from "../../Models/ProjectFormData";
import { ActionTypes } from "../ProjectActionTypes";
import { LicenseGroup } from "../../Models/LicenseGroup";
import { ProjectDailyJob } from "../../Models/ProjectDailyJobs";

export type ProjectModalAction = {
  type: any;
  payload?: ProjectModalPayload;
};

export type ProjectModalPayload = {
  project?: ProjectFormData;
  projectId?: number;
  projectLicenses?: LicenseGroup;
  interfaces_old?: Interface[];
  dailyjobs?: ProjectDailyJob[];
  dataconnections?: DataConnections;
  errorCode?: string;
};

export const getProjectLoading = () => {
  return { type: ActionTypes.GET_PROJECT };
};

export const getProjectSuccess = (
  project: ProjectFormData,
  interfaces_old: Interface[],
  dailyjobs: ProjectDailyJob[],
  dataconnections: DataConnections
) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.GET_PROJECT_SUCCESS,
    payload: {
      project: project,
      interfaces_old: interfaces_old,
      dailyjobs: dailyjobs,
      dataconnections: dataconnections
    },
  };
  return projectAction;
};

export const getProjectError = (errorCode: string) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.GET_PROJECT_ERROR,
    payload: { errorCode: errorCode },
  };
  return projectAction;
};

export const addProjectError = (errorCode: string) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.ADD_PROJECT_ERROR,
    payload: { errorCode: errorCode },
  };
  return projectAction;
};

export const updateProjectError = (errorCode: string) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.UPDATE_PROJECT_ERROR,
    payload: { errorCode: errorCode },
  };
  return projectAction;
};

export const setProject = (project: ProjectFormData) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.SET_PROJECT,
    payload: { project: project },
  };
  return projectAction;
};

export const clearProjectDetails = () => {
  return { type: ActionTypes.CLEAR_PROJECT };
};

export const getProjectLicenses = (licenses: LicenseGroup) => {
  const projectAction: ProjectModalAction = {
    type: ActionTypes.GET_PROJECT_LICENSES,
    payload: { projectLicenses: licenses },
  };
  return projectAction;
};
